import { createAssortmentApp } from './src/create-app';
import { STYLE_SCOPE_CLASS } from './src/webshell-embed/embedded';

// Standalone entry, for per-client deployments and local dev. The federated remote entry
// (src/webshell-embed/WebshellMain.vue) calls the same factory after putting AO into embedded mode.
//
// MSW belongs here rather than in the shared factory: the embedded remote runs in the shell's
// document and must never register a service worker there. Started before the app so the mocks
// intercept its context XHRs.
if (import.meta.env.VITE_ENABLE_MSW === 'true') {
  const { worker } = await import('./msw-browser-worker');
  await worker.start({
    serviceWorker: { url: '/mockServiceWorker.js' },
    onUnhandledRequest: 'bypass',
  });
}

// AO's CSS is scoped under the style scope class at build time (vite.config.js). Standalone mounts
// under <body>, which needs the class for the styles to apply page-wide; embedded, WebshellMain.vue's
// host div is the ancestor instead.
document.body.classList.add(STYLE_SCOPE_CLASS);

createAssortmentApp({ mountTarget: '#app', routerBase: import.meta.env.BASE_URL });
